import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CountryStorageService } from '../../services/country.storage.service';

@Component({
  selector: 'app-country-redirect',
  template: '<div>Redirecting...</div>',
  standalone: true
})
export class CountryRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private countryStorage: CountryStorageService
  ) {}

  ngOnInit(): void {
    const currentCountry = this.countryStorage.currentCountry;
    
    if (currentCountry && currentCountry.code) {
      // Redirect to country-specific route
      this.router.navigate([`/${currentCountry.code.toLowerCase()}/home`]);
    } else {
      // No default country or code, redirect to home without country code
      this.router.navigate(['/home']);
    }
  }
}
